import { Injectable } from '@angular/core';
import jsPDF from 'jspdf';
import autoTable, { RowInput, UserOptions } from 'jspdf-autotable';
import { PeriodoPipe } from 'src/app/Shared/Pipes/periodo.pipe';
import { AlumnoService } from 'src/app/Shared/Services/alumno.service';
import { EvaluacionDocenteService } from 'src/app/Shared/Services/evaluacion-docente.service';
import { MateriasService } from 'src/app/Shared/Services/materias.service';
import { PersonalService } from 'src/app/Shared/Services/personal.service';
import { switchMap } from 'rxjs/operators';
import { Alumno } from 'src/app/Shared/Interfaces/alumno.interface';
import { GruposService } from 'src/app/Shared/Services/grupos.service';
import { Grupo } from 'src/app/Shared/Interfaces/grupo.interface';
import { Grupo as _Grupo } from '../../Grupos/Interfaces/grupo.interface';
import { Materia } from 'src/app/Shared/Interfaces/materia.interface';
import { Personal } from 'src/app/Shared/Interfaces/personal.interface';
import { EvaluacionDocente } from 'src/app/Shared/Interfaces/evaluacion-docente.interface';
import { CarrerasService } from 'src/app/Shared/Services/carreras.service';
import { EspecialidadesService } from 'src/app/Shared/Services/especialidades.service';
import { Carrera } from 'src/app/Shared/Interfaces/carrera.interface';
import { of } from 'rxjs';
import { Especialidad } from 'src/app/Shared/Interfaces/especialidad.interface';
import { NivelAcademicoPipe } from 'src/app/Shared/Pipes/nivel-academico.pipe';
import moment from 'moment';

export type PDF = {
    file: Blob;
    filename: string;
};

@Injectable({
    providedIn: 'root',
})
export class EvaluacionDocentePDFService {
    constructor(
        private periodoPipe: PeriodoPipe,
        private nivelAcademicoPipe: NivelAcademicoPipe,
        private evaluacionDocenteService: EvaluacionDocenteService,
        private alumnoService: AlumnoService,
        private materiaService: MateriasService,
        private personalService: PersonalService,
        private gruposServices: GruposService,
        private carreraService: CarrerasService,
        private especialidadService: EspecialidadesService
    ) {}

    async generarPDF(
        periodo: string,
        numero_control: string
    ): Promise<PDF | undefined> {
        return new Promise<PDF | undefined>((resolve) => {
            let _grupos: _Grupo[] = [];

            let alumno: Alumno;
            let grupos: Grupo[];
            let materias: Materia[];
            let docentes: Personal[];
            let evaluaciones: EvaluacionDocente[];
            let carrera: Carrera;
            let especialidad: Especialidad;
            this.alumnoService
                .getAlumno(numero_control)
                .pipe(
                    switchMap((alumn) => {
                        alumno = alumn;
                        return this.carreraService.getCarrera(
                            alumno.carrera,
                            alumno.reticula
                        );
                    })
                )
                .pipe(
                    switchMap((carr) => {
                        carrera = carr;
                        if (alumno.especialidad > 0) {
                            return this.especialidadService.obtenerEspecialidad(
                                alumno.especialidad
                            );
                        } else {
                            return of(undefined);
                        }
                    })
                )
                .pipe(
                    switchMap((esp) => {
                        especialidad = esp;
                        return this.gruposServices.getGroupsB(
                            alumno.carrera,
                            alumno.reticula,
                            periodo,
                            0
                        );
                    })
                )
                .pipe(
                    switchMap((gruposB) => {
                        grupos = gruposB;
                        return this.gruposServices.getGroupsP(
                            alumno.carrera,
                            alumno.reticula,
                            periodo,
                            0
                        );
                    })
                )
                .pipe(
                    switchMap((gruposP) => {
                        grupos = grupos.concat(gruposP);
                        return this.evaluacionDocenteService.findEval(
                            numero_control,
                            periodo
                        );
                    })
                )
                .pipe(
                    switchMap((eva) => {
                        evaluaciones = eva;
                        return this.materiaService.obtenerMateriasCarrera(
                            alumno.carrera,
                            alumno.reticula
                        );
                    })
                )
                .pipe(
                    switchMap((mat) => {
                        materias = mat;
                        return this.personalService.getDocentes();
                    })
                )
                .subscribe((docencia) => {
                    docentes = docencia;

                    const totalResp: number =
                        parseInt(periodo) <= 20111 ? 27 : 48;

                    grupos.forEach((grupo) => {
                        const materia: Materia = materias.find(
                            (materia) =>
                                materia.materia == (grupo.materia ?? '')
                        );
                        const materiaSeleccionada: EvaluacionDocente =
                            evaluaciones.find(
                                (materiaS) =>
                                    materiaS.materia ==
                                        (materia.materia ?? '') &&
                                    materiaS.grupo == (grupo.grupo ?? '')
                            );

                        if (
                            materiaSeleccionada?.respuestas.length == totalResp
                        ) {
                            const docente: Personal = docentes.find(
                                (docente) => docente.rfc == (grupo.rfc ?? '')
                            );
                            const _grupo: _Grupo = {
                                clave_materia: materia.materia,
                                nombre_materia:
                                    materia.nombre_abreviado_materia,
                                nombre_completo_materia:
                                    materia.nombre_completo_materia,
                                grupo: materiaSeleccionada.grupo,
                                rfc_docente: docente?.rfc ?? 'Sin Asignar',
                                nombre_docente: docente
                                    ? (
                                          docente.apellidos_empleado +
                                          ' ' +
                                          docente.nombre_empleado
                                      ).toUpperCase()
                                    : 'SIN DOCENTE',
                                // tipo_docente: grupo.tipo_personal ?? '',
                            };
                            _grupos.push(_grupo);
                        }
                    });

                    if (_grupos.length > 0) {
                        const doc = new jsPDF();

                        var header =
                            '../../../../../../../assets/img/logos.png';

                        doc.addImage(header, 'PNG', 10, 6, 110, 18);

                        let titleTable: UserOptions = {
                            margin: { top: 7, bottom: 15 },
                            showHead: 'everyPage',
                            theme: 'plain',
                            styles: {
                                halign: 'right',
                                minCellHeight: 3,
                            },
                            bodyStyles: {
                                cellPadding: 0.8,
                            },
                            body: [
                                [
                                    {
                                        title: 'Secretaria de Educación Pública',
                                        styles: {
                                            textColor: [128, 43, 43],
                                            fontSize: 10,
                                            fontStyle: 'bold',
                                            valign: 'bottom',
                                        },
                                    },
                                ],
                                [
                                    {
                                        title: 'Tecnológico Nacional de México',
                                        styles: {
                                            textColor: [24, 61, 92],
                                            fontSize: 10,
                                            fontStyle: 'bold',
                                            valign: 'middle',
                                        },
                                    },
                                ],
                                [
                                    {
                                        title: 'Instituto Tecnológico de Tehuacán',
                                        styles: {
                                            textColor: [0, 0, 0],
                                            fontSize: 10,
                                            fontStyle: 'bold',
                                            valign: 'top',
                                        },
                                    },
                                ],
                                [
                                    {
                                        title: '',
                                    },
                                ],
                                [
                                    {
                                        title: 'Evaluación Docente',
                                        styles: {
                                            textColor: [128, 43, 43],
                                            fontSize: 12,
                                            fontStyle: 'bold',
                                            valign: 'middle',
                                            halign: 'center',
                                            cellPadding: 0,
                                        },
                                    },
                                ],
                                [
                                    {
                                        title: this.periodoPipe.transform(
                                            periodo
                                        ),
                                        styles: {
                                            textColor: [0, 0, 0],
                                            fontSize: 11,
                                            fontStyle: 'bold',
                                            valign: 'middle',
                                            halign: 'center',
                                            cellPadding: 0,
                                        },
                                    },
                                ],
                            ],
                        };
                        autoTable(doc, titleTable);

                        let tableData: UserOptions = {
                            margin: { top: 40, bottom: 10 },
                            headStyles: {
                                halign: 'center',
                                cellPadding: {
                                    left: 1,
                                    right: 1,
                                    top: 0.2,
                                    bottom: 0.2,
                                },
                                lineWidth: 0.1,
                                valign: 'middle',
                            },
                            bodyStyles: {
                                halign: 'center',
                                cellPadding: {
                                    left: 1,
                                    right: 1,
                                    top: 0.2,
                                    bottom: 0.2,
                                },
                                lineWidth: 0.1,
                                valign: 'middle',
                            },
                            theme: 'grid',
                            head: [
                                [
                                    {
                                        title: 'No. Control S.E.P',
                                        styles: {
                                            fillColor: [24, 61, 92],
                                            textColor: [255, 255, 255],
                                            fontSize: 10,
                                            lineColor: [24, 61, 92],
                                            fontStyle: 'bold',
                                            cellWidth: 30,
                                        },
                                    },
                                    {
                                        title: 'Nombre del Alumno',
                                        styles: {
                                            fillColor: [24, 61, 92],
                                            textColor: [255, 255, 255],
                                            fontSize: 10,
                                            lineColor: [24, 61, 92],
                                            fontStyle: 'bold',
                                        },
                                        colSpan: 2,
                                    },
                                    {
                                        title: 'Semestre',
                                        styles: {
                                            fillColor: [24, 61, 92],
                                            textColor: [255, 255, 255],
                                            fontSize: 10,
                                            lineColor: [24, 61, 92],
                                            fontStyle: 'bold',
                                            cellWidth: 30,
                                        },
                                    },
                                    {
                                        title: 'Ciclo de Estudios',
                                        styles: {
                                            fillColor: [24, 61, 92],
                                            textColor: [255, 255, 255],
                                            fontSize: 10,
                                            lineColor: [24, 61, 92],
                                            fontStyle: 'bold',
                                            cellWidth: 50,
                                        },
                                    },
                                ],
                            ],
                            body: [
                                [
                                    {
                                        title: alumno.no_de_control,
                                        styles: {
                                            valign: 'middle',
                                            fontSize: 9,
                                            fontStyle: 'bold',
                                            lineColor: [250, 250, 250],
                                            fillColor: [245, 245, 245],
                                            cellWidth: 30,
                                        },
                                    },
                                    {
                                        title:
                                            alumno.apellido_paterno +
                                            ' ' +
                                            alumno.apellido_materno +
                                            ' ' +
                                            alumno.nombre_alumno,
                                        colSpan: 2,
                                        styles: {
                                            valign: 'middle',
                                            fontSize: 9,
                                            fontStyle: 'bold',
                                            lineColor: [250, 250, 250],
                                            fillColor: [245, 245, 245],
                                        },
                                    },
                                    {
                                        title: alumno.semestre.toString(),
                                        styles: {
                                            valign: 'middle',
                                            fontSize: 9,
                                            fontStyle: 'bold',
                                            lineColor: [250, 250, 250],
                                            fillColor: [245, 245, 245],
                                            cellWidth: 30,
                                        },
                                    },
                                    {
                                        title: this.nivelAcademicoPipe
                                            .transform(
                                                alumno.nivel_escolar.toUpperCase()
                                            )
                                            .toUpperCase(),
                                        styles: {
                                            valign: 'middle',
                                            fontSize: 9,
                                            fontStyle: 'bold',
                                            lineColor: [250, 250, 250],
                                            fillColor: [245, 245, 245],
                                            cellWidth: 50,
                                        },
                                    },
                                ],
                                [
                                    {
                                        title: 'Carrera',
                                        styles: {
                                            fillColor: [24, 61, 92],
                                            textColor: [255, 255, 255],
                                            fontSize: 10,
                                            lineColor: [24, 61, 92],
                                            fontStyle: 'bold',
                                        },

                                        colSpan: 2,
                                    },
                                    {
                                        title: 'Especialidad',
                                        styles: {
                                            fillColor: [24, 61, 92],
                                            textColor: [255, 255, 255],
                                            lineColor: [24, 61, 92],
                                            fontSize: 10,
                                            fontStyle: 'bold',
                                        },
                                        colSpan: 3,
                                    },
                                ],

                                [
                                    {
                                        title: carrera.nombre_reducido,
                                        styles: {
                                            valign: 'middle',
                                            fontSize: 9,
                                            fontStyle: 'bold',
                                            lineColor: [250, 250, 250],
                                            fillColor: [245, 245, 245],
                                        },
                                        colSpan: 2,
                                    },
                                    {
                                        title: especialidad
                                            ? especialidad.nombre_especialidad
                                            : 'SIN ESPECIALIDAD',
                                        styles: {
                                            valign: 'middle',
                                            fontSize: 9,
                                            fontStyle: 'bold',
                                            lineColor: [250, 250, 250],
                                            fillColor: [245, 245, 245],
                                        },
                                        colSpan: 3,
                                    },
                                ],
                            ],
                        };
                        autoTable(doc, tableData);

                        let tabletTitle1: UserOptions = {
                            margin: { top: 10 },
                            bodyStyles: {
                                lineWidth: 0,
                            },
                            body: [
                                [
                                    {
                                        title: 'Docentes Evaluados',
                                        styles: {
                                            textColor: [24, 61, 92],
                                            fontSize: 10,
                                            fontStyle: 'bold',
                                            valign: 'middle',
                                            halign: 'center',
                                            fillColor: 'white',
                                            cellPadding: 0,
                                        },
                                    },
                                ],
                            ],
                        };
                        autoTable(doc, tabletTitle1);

                        const tabla: { data: string; rows: number }[] = [];
                        const columns: string[] = ['rfc_docente'];
                        columns.forEach((column) => {
                            _grupos.forEach((evaluacion) => {
                                const dataColumn: string = evaluacion[column];
                                const celda: {
                                    data: string;
                                    rows: number;
                                } = {
                                    data: dataColumn,
                                    rows: _grupos.filter(
                                        (ev) => ev[column] == dataColumn
                                    ).length,
                                };
                                if (
                                    !tabla.some((c) => c.data == celda.data) &&
                                    celda.rows > 1
                                ) {
                                    tabla.push(celda);
                                }
                            });
                        });

                        console.log(tabla);

                        let tableGrupos: UserOptions = {
                            margin: { top: 10 },
                            theme: 'striped',
                            headStyles: {
                                halign: 'center',
                                cellPadding: 0.1,
                                fillColor: [24, 61, 92],
                                fontSize: 9,
                                lineWidth: 0.1,
                                valign: 'middle',
                            },
                            bodyStyles: {
                                textColor: 'black',
                                fontSize: 8,
                                cellPadding: {
                                    left: 1,
                                    right: 1,
                                    top: 0.2,
                                    bottom: 0.2,
                                },
                                lineWidth: 0.1,
                                valign: 'middle',
                            },
                            head: [
                                [
                                    {
                                        content: 'Docente',
                                        colSpan: 2,
                                    },
                                    {
                                        content: 'Materia',
                                        colSpan: 2,
                                    },
                                    {
                                        content: 'Grupo',
                                        rowSpan: 2,
                                    },
                                ],
                                [
                                    {
                                        content: 'RFC',
                                    },
                                    {
                                        content: 'Nombre',
                                    },
                                    {
                                        content: 'Clave',
                                    },
                                    {
                                        content: 'Nombre',
                                    },
                                ],
                            ],
                            body: [],
                        };

                        _grupos
                            .sort((a, b) =>
                                a.rfc_docente.localeCompare(b.rfc_docente)
                            )
                            .filter(
                                (g) =>
                                    g.rfc_docente.toUpperCase() != 'SIN ASIGNAR'
                            )
                            .forEach((result) => {
                                const row: RowInput = [];
                                let rowSpan =
                                    tabla.find(
                                        (c) => c.data == result.rfc_docente
                                    )?.rows ?? 1;
                                if (rowSpan > 1) {
                                    tabla.find(
                                        (c) => c.data == result.rfc_docente
                                    ).rows = 0;
                                }
                                if (rowSpan > 0) {
                                    row.push(
                                        {
                                            content:
                                                result.rfc_docente.toUpperCase(),
                                            rowSpan,
                                            styles: {
                                                halign: 'center',
                                                cellWidth: 30,
                                            },
                                        },
                                        {
                                            content: result.nombre_docente,
                                            rowSpan,
                                            styles: {
                                                halign: 'left',
                                                minCellWidth: 60,
                                            },
                                        }
                                    );
                                }

                                row.push(
                                    {
                                        content: result.clave_materia,
                                        styles: {
                                            halign: 'center',
                                            cellWidth: 15,
                                        },
                                    },
                                    {
                                        content: result.nombre_completo_materia,
                                        styles: {
                                            minCellWidth: 60,
                                            halign: 'left',
                                        },
                                    },
                                    {
                                        content: result.grupo,
                                        styles: {
                                            halign: 'center',
                                            cellWidth: 15,
                                        },
                                    }
                                );
                                tableGrupos.body.push(row);
                            });

                        _grupos
                            .filter(
                                (g) =>
                                    g.rfc_docente.toUpperCase() == 'SIN ASIGNAR'
                            )
                            .forEach((result) => {
                                let rowSpan =
                                    tabla.find(
                                        (c) => c.data == result.rfc_docente
                                    )?.rows ?? 1;
                                if (rowSpan > 1) {
                                    tabla.find(
                                        (c) => c.data == result.rfc_docente
                                    ).rows = 0;
                                }
                                tableGrupos.body.push([
                                    {
                                        content:
                                            result.rfc_docente.toUpperCase(),
                                        colSpan: 2,
                                        rowSpan,
                                        styles: {
                                            halign: 'center',
                                            minCellWidth: 90,
                                        },
                                    },
                                    {
                                        content: result.clave_materia,
                                        styles: {
                                            halign: 'center',
                                            cellWidth: 15,
                                        },
                                    },
                                    {
                                        content: result.nombre_completo_materia,
                                        styles: {
                                            minCellWidth: 60,
                                            halign: 'left',
                                        },
                                    },
                                    {
                                        content: result.grupo,
                                        styles: {
                                            halign: 'center',
                                            cellWidth: 15,
                                        },
                                    },
                                ]);
                            });
                        autoTable(doc, tableGrupos);

                        let tableFirma: UserOptions = {
                            margin: { top: 10 },
                            bodyStyles: {
                                lineWidth: 0,
                                fillColor: 'white',
                            },
                            body: [
                                [
                                    {
                                        title: '',
                                        styles: {
                                            fillColor: 'white',
                                            cellPadding: 10,
                                        },
                                    },
                                    {
                                        title: '_____________________________________________',
                                        styles: {
                                            fillColor: 'white',
                                            halign: 'center',
                                            valign: 'bottom',
                                            cellPadding: 0,
                                        },
                                    },
                                    {
                                        title: '',
                                        styles: {
                                            fillColor: 'white',
                                            cellPadding: 10,
                                        },
                                    },
                                ],
                                [
                                    {
                                        title: 'Nombre y Firma',
                                        colSpan: 3,
                                        styles: {
                                            fillColor: 'white',
                                            halign: 'center',
                                            cellPadding: 0,
                                        },
                                    },
                                ],
                            ],
                        };
                        autoTable(doc, tableFirma);

                        //footer
                        doc.setFontSize(8);
                        doc.setTextColor('gray');
                        doc.text(moment(new Date()).format('LL'), 20, 290);

                        doc.setTextColor('black');
                        doc.setDocumentProperties({
                            title: `${periodo} - Evaluacion Docente`,
                        });

                        resolve({
                            file: doc.output('blob'),
                            filename: `${alumno.no_de_control}-${alumno.nombre_alumno}- Evaluacion Docente.pdf`,
                        });
                    } else {
                        resolve(undefined);
                    }
                });
        });
    }
}
